import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import { useQuery } from '@tanstack/react-query';
import UncontrolledExpandableRow from 'src/components/shared/uncontrolledExpandableRow/uncontrolledExpandableRow';
import { getAccommodationQueryOptions } from 'src/services/accommodation/accommodationQueries';

import './employeeInformation.scss';

interface TableItem {
  label: string;
  value: string | number;
  dataCy: string;
}

const EmployeeInformation = () => {
  const [employeeInformationTableData, setEmployeeInformationTableData] = useState<TableItem[]>([]);

  const { placementId } = useParams();
  const { data: placementDetails, isSuccess } = useQuery(
    getAccommodationQueryOptions.accommodationDetails(+placementId!),
  );

  useEffect(() => {
    if (isSuccess) {
      const items: TableItem[] = [
        {
          label: 'Login',
          value: placementDetails.login,
          dataCy: 'login',
        },
        {
          label: 'Employee ID',
          value: placementDetails.employeeId,
          dataCy: 'employeeID',
        },
        {
          label: 'Person ID',
          value: placementDetails.personId,
          dataCy: 'personID',
        },
        {
          label: 'Job',
          value: placementDetails.job,
          dataCy: 'job',
        },
        {
          label: 'Home Location',
          value: placementDetails.fc,
          dataCy: 'siteLocation',
        },
        {
          label: 'Home Shift',
          value: placementDetails.shiftCode,
          dataCy: 'shift',
        },
      ];

      setEmployeeInformationTableData(items);
    }
  }, [placementDetails, isSuccess]);

  return isSuccess ? (
    <>
      <Table
        headerRows={1}
        headerColumns={1}
        rowComponents={[UncontrolledExpandableRow, TableRow]}
        showStripes={true}
        showDividers={true}
      >
        <TableRow>
          <TableCell></TableCell>
          <TableCell>Employee Information</TableCell>
        </TableRow>
        {employeeInformationTableData.map(({ value, label, dataCy }, index) => (
          <TableRow key={index}>
            <TableCell>{label}</TableCell>
            <TableCell data-cy={`placement-details__home-process__${dataCy}`}>{value}</TableCell>
          </TableRow>
        ))}
      </Table>
    </>
  ) : null;
};
export default EmployeeInformation;
